<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout
        class="weui-cells__group textarea-cell"
        :view-config="customViewConfig"
      >
        <div slot="oa_address">
          <div class="weui-cells__title">
            {{ customLabel.oa_address || "外出地点" }}
          </div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请填写"
                  rows="2"
                  v-model="form.main.oa_address"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.oa_address ? form.main.oa_address.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
      </custom-layout>
      <div class="weui-cells__group">
        <custom-layout class="weui-cells" :view-config="customViewConfig">
          <combo-field
            slot="oa_outtype"
            :label="customLabel.oa_outtype || '外出类型'"
            placeholder="请选择"
            v-model="form.main.oa_outtype"
            url="/api/oa/outtype/getCombo"
          />
          <!-- <combo-search-box
            slot="oa_outtype"
            :label="customLabel.oa_outtype || '外出类型'"
            placeholder="请选择或输入"
            v-model="form.main.oa_outtype"
            url="/api/oa/outtype/getCombo"
            ref="combo1"
          /> -->
          <datetime-field
            slot="oa_startime"
            :label="customLabel.oa_startime || '开始时间'"
            v-model="form.main.oa_startime"
          />
          <datetime-field
            slot="oa_endtime"
            :label="customLabel.oa_endtime || '结束时间'"
            v-model="form.main.oa_endtime"
          />
          <div class="weui-cell" slot="oa_alltimes">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.oa_alltimes || "外出时长"
              }}</label>
            </div>
            <div class="weui-cell__bd flex">
              <input
                class="weui-input"
                type="number"
                v-model="form.main.oa_alltimes"
                placeholder="请填写"
                minvalue="0.01"
              />
              <span>h</span>
            </div>
          </div>
        </custom-layout>
      </div>
      <custom-layout
        class="weui-cells__group textarea-cell"
        :view-config="customViewConfig"
      >
        <div slot="oa_remark">
          <div class="weui-cells__title">
            {{ customLabel.oa_remark || "外出事由" }}
          </div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请填写"
                  rows="3"
                  v-model="form.main.oa_remark"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.oa_remark ? form.main.oa_remark.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.oa_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
// import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import ComboField from "@/components/field/ComboField.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    // ComboSearchBox,
    ComboField,
    DatetimeField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/outapply",
      codeField: "oa_code",
      statusField: "oa_statuscode",
      caller: "OutApply",
      xtype: "oa-outapply-formpanel",
      form: {
        main: {
          oa_address: null,
          oa_outtype: null,
          oa_startime: null,
          oa_endtime: null,
          oa_remark: null,
          oa_alltimes: null,
        },
      },
    };
  },
  computed: {
    oa_startime() {
      return this.form.main.oa_startime;
    },
    oa_endtime() {
      return this.form.main.oa_endtime;
    },
  },
  watch: {
    oa_startime: function () {
      this.countHourDiff()
    },
    oa_endtime: function () {
      this.countHourDiff()
    },
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.oa_address) {
        me.$weui.topTips("请选择外出地点", 2000);
      } else if (!main.oa_startime) {
        me.$weui.topTips("请填写开始时间", 2000);
      } else if (!main.oa_endtime) {
        me.$weui.topTips("请填写结束时间", 2000);
      } else if (!main.oa_alltimes || main.oa_alltimes <= 0 || (main.oa_alltimes - me.diff > 0)) {
        me.$weui.topTips("外出时长错误", 2000);
      } else if (!main.oa_remark) {
        me.$weui.topTips("请填写外出事由", 2000);
      } else {
        // me.result_combo_save(main.oa_outtype);
        me.p_save();
      }
    },
    // result_combo_save(type) {
    //   var me = this;
    //   let combo1 = me.$refs.combo1.data,
    //     save = combo1.some((item) => {
    //       return item.value == type;
    //     });
    //   if (!save) {
    //     me.$ajax({
    //       url: "/api/oa/outtype/save",
    //       method: "POST",
    //       jsonData: {
    //         ot_name: type,
    //         id: 0,
    //       },
    //     }).then();
    //   }
    // },
    /**
     * 日期选择最小单位是一刻钟，计算出的0.25 0.75需要变为0.5 1
     */
    countHourDiff() {
      var {oa_startime, oa_endtime} = this.form.main;

      if (!oa_startime || !oa_endtime) return 

      oa_startime = oa_startime.replace(' ', 'T')
      oa_endtime = oa_endtime.replace(' ', 'T')

      var s_time = new Date(oa_startime).getTime(),
        e_time = new Date(oa_endtime).getTime(),
        diff = e_time - s_time;

      diff = diff/1000/60/60
      // let temp_oa_alltimes = oa_alltimes * 100 + ''
      // let a = temp_oa_alltimes.at(-2)
      // if(a == 7 || a == 2) oa_alltimes += 0.25
      this.diff = diff

      if(diff <= 0) {
        this.$weui.topTips("结束时间需要大于开始时间", 2000);
        this.form.main.oa_alltimes = null
        return
      }

      this.form.main.oa_alltimes = diff
    }
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
</style>